import React from 'react'
import PropTypes from 'prop-types'
import Label from './Label'
import InputWrap from './InputWrap'
import DatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import useInput from '../../hooks/useInput'
import { da } from 'date-fns/locale/da'
import { isAfter, isSameDay } from 'date-fns'

registerLocale('da', da)

export default function DateInput ({
  name,
  context,
  label,
  required = false,
  size,
  time,
  placeholder,
  minDate
}) {

  const { getValue, setValue } = useInput(context)

  const handleOnChange = function (date) {
    setValue(name, date.toISOString().slice(0, 19).replace('T', ' '))
  }

  const handleSelected = () => {
    if (!minDate) {
      return Date.parse(getValue(name))
    }

    if (isAfter(Date.parse(getValue(name)), minDate) || isSameDay(Date.parse(getValue(name)), minDate)) {
      return Date.parse(getValue(name))
    } else {
      return null
    }
  }

  return (
    <InputWrap size={size}>
      <Label required={required}>{label}</Label>
      <DatePicker selected={handleSelected()} onChange={handleOnChange} showTimeSelect={time} placeholderText={placeholder} locale={'da'} timeCaption={'Tid'} minDate={minDate} />
    </InputWrap>
  )
}

DateInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['half', 'third']),
}